module.exports = __webpack_public_path__ + "img/blender.c29edd86.png";